import { DialogM } from "@common/components/alert/dialog/Dialog"
import FilledButtonM from "@common/components/button/FilledButtonM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { useInterval } from "@common/utils/useInterval"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { setVideoRecord } from "@data/redux/actions/camera"
import { useNavigation } from "@react-navigation/native"
import React, { useContext, useEffect, useState } from "react"
import { ActivityIndicator, Dimensions, View } from "react-native"
import { TouchableOpacity } from "react-native-gesture-handler"
import { IconButton } from "react-native-paper"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { connect } from "react-redux"
import { ImagesList } from "../../../common/camera/CameraImagesM"
import VideoRecordingComponent from "./VideoRecordingComponent"

const VideoRecordingScreen = (props) => {
    const questionId = props.route?.params?.questionId ?? 1
    const testMode = props.route?.params?.testMode ?? 0

    const [testCategory, setTestCategory] = useState(
        props.route?.params?.testCategory ?? "motivation"
    )

    useEffect(() => {
        if (props.route?.params?.testCategory) {
            setTestCategory(props.route?.params?.testCategory)
        }
    }, [props.route?.params?.testCategory])

    const testModeBool = parseInt(testMode?.toString()) > 0

    const dimensions = useContext(DimensionsContext)
    const navigation = useNavigation()
    const insets = useSafeAreaInsets()
    const question = props.testQuestions?.find(
        (q) => q?.id?.toString() === questionId
    )
    const containActivity = question?.activity
    const questionDisplay = question?.activity?.student_class
        ? `${question?.question} (copie d'un élève en ${question?.activity.student_class})`
        : question?.question
    const [answerDuration, setAnswerDuration] = useState(
        question?.answer_duration
    )
    const [recordingStarted, setRecordingStarted] = useState(false)
    const [openImageViewer, setOpenImageViewer] = useState(false)

    const testModeText =
        "Avant la question, vérifie que tout fonctionne bien, puis clique sur le bouton ci-dessous pour commencer"

    const minutes = Math.floor(answerDuration / 60)

    const seconds = answerDuration % 60

    useEffect(() => {
        if (testMode) props.setVideoRecord(null)
    }, [])

    function padTo2Digits(num) {
        return num.toString().padStart(2, "0")
    }

    const result = `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`

    useInterval(
        () => {
            setAnswerDuration((p) => p - 1)
        },
        answerDuration > 0 && !testModeBool && recordingStarted ? 1000 : null
    )

    const materialAttachment = question?.activity?.material?.attachments[0]

    const logImages = question?.activity?.activity_logs?.filter(
        (al) => al?.step === 2 && al?.action === "step_media_sent"
    )

    const images = logImages?.map((x) => x?.work_attachment)

    const modalStyle = {
        backgroundColor: "rgba(0, 0, 0, 0.5)",
    }

    const isSmallScreen = Dimensions.get("window").width < 800

    return (
        <View
            style={{
                flex: 1,
                backgroundColor: theme.colors.black,
                paddingTop: insets.top,
                alignItems: "center",
            }}
        >
            <VideoRecordingComponent
                questionId={questionId}
                setRecordingStarted={setRecordingStarted}
                testMode={testModeBool}
                answerDuration={answerDuration}
            />
            <View
                style={{
                    position: "absolute",
                    top: insets.top,
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "space-around",
                    backgroundColor: theme.colors.blackTransparent2,
                    paddingHorizontal: 10,
                    paddingVertical: 10,
                    width: "100%",
                }}
            >
                <View
                    style={{
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    <TextM
                        color={theme.colors?.white}
                        fontSize={12}
                        fontWeight={"Bold"}
                        style={{
                            width: dimensions?.width - 80,
                            textAlign: "center",
                        }}
                        wrap
                    >
                        {testModeBool ? testModeText : questionDisplay}
                    </TextM>
                    {testCategory === "technical" && (
                        <TextM
                            color={theme.colors.white}
                            fontSize={12}
                            fontWeight={"Bold"}
                            style={{
                                width: dimensions?.width - 80,
                                textAlign: "center",
                            }}
                            wrap
                        >
                            Dans la vidéo tu peux faire comme si tu
                            t&apos;adressais à l&apos;élève directement.
                        </TextM>
                    )}
                </View>
                {!openImageViewer && (
                    <IconButton
                        icon={"times"}
                        iconColor={theme.colors.white}
                        containerColor={theme.colors.transparent}
                        size={32}
                        style={{
                            position: "absolute",
                            left: -5,
                        }}
                        onPress={() => {
                            if (testModeBool) navigation.goBack()
                            else
                                DialogM.show({
                                    text1: "Veux-tu vraiment quitter ?",
                                    text2: "Ta réponse ne sera pas enregistrée",
                                    buttonText1: "Quitter",
                                    buttonColor1: theme.colors.error,
                                    onPress: () => {
                                        navigation.goBack()
                                    },
                                    buttonText2: "Annuler",
                                })
                        }}
                    />
                )}
            </View>
            <View
                style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    flexDirection: "column",
                    justifyContent: "flex-end",
                    alignItems: "center",
                }}
            >
                <View
                    style={{
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "flex-end",
                    }}
                >
                    {containActivity && (
                        <TouchableOpacity
                            onPress={() => {
                                setOpenImageViewer(true)
                            }}
                            style={{
                                flexDirection: isSmallScreen ? "column" : "row",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <ImagesList
                                images={[
                                    {
                                        uri: materialAttachment,
                                        width: 100,
                                        height: 100,
                                    },
                                ]}
                                contentHeight={100}
                                longPressDisabled
                                style={{
                                    width: "100%",
                                }}
                                modalStyle={modalStyle}
                                onDismissExtra={() => {
                                    setOpenImageViewer(false)
                                }}
                            />
                            <ImagesList
                                images={[
                                    {
                                        uri: images[0],
                                        width: 100,
                                        height: 100,
                                    },
                                ]}
                                contentHeight={100}
                                longPressDisabled
                                style={{
                                    width: "100%",
                                }}
                                modalStyle={modalStyle}
                                onDismissExtra={() => {
                                    setOpenImageViewer(false)
                                }}
                            />
                        </TouchableOpacity>
                    )}
                    <View
                        style={{
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {!testModeBool && recordingStarted && (
                            <TextM
                                fontWeight="Medium"
                                fontSize={14}
                                color={theme.colors.error}
                                style={{
                                    marginBottom: 4,
                                }}
                            >
                                {"Enregistrement en cours"}
                            </TextM>
                        )}
                        {!testModeBool && (
                            <View
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    marginBottom: 10,
                                }}
                            >
                                <TextM
                                    color={theme.colors.error}
                                    fontWeight={"Bold"}
                                    fontSize={25}
                                >
                                    {result}
                                </TextM>
                                {!recordingStarted && (
                                    <ActivityIndicator
                                        size="small"
                                        color={theme.colors.error}
                                        style={{
                                            marginLeft: 10,
                                        }}
                                    />
                                )}
                            </View>
                        )}
                    </View>
                </View>
                {!testModeBool && recordingStarted && (
                    <FilledButtonM
                        color={theme.colors.error}
                        onPress={() => {
                            DialogM.show({
                                text1: "Veux-tu vraiment terminer l'enregistrement ?",
                                text2: "Ta réponse sera enregistrée",
                                buttonText1: "Terminer",
                                buttonColor1: theme.colors.primary,
                                onPress: () => {
                                    setAnswerDuration(0)
                                },
                                buttonText2: "Annuler",
                            })
                        }}
                        label={"Terminer"}
                    />
                )}
                {testModeBool && (
                    <FilledButtonM
                        color={theme.colors.success}
                        onPress={() => {
                            navigation.replace("application-interview", {
                                testCategory,
                            })
                        }}
                        label={"C'est parti !"}
                    />
                )}
            </View>
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        testQuestions: state.data.tutors?.testQuestions,
        videoRecord: state.camera?.videoRecord,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setVideoRecord,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VideoRecordingScreen)
